export { renderOption_unstable as renderOption } from '@fluentui/react-combobox';
